import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    // const [orderVariant, setorderVariant] = React.useState(props.OrderVariant);
    // React.useEffect(()=>{
    //   setorderVariant(props.OrderVariant)
    // },[props.AvtalTyp])

    return (
        <form className={classes.root}>
            <div>
                <TextField
                    select
                    label={<IntlMessages id="input.Order.variant"/>}
                    variant="outlined"
                    name="OrderVariant"
                    size="small"
                    value={props.OrderVariant}
                    fullWidth
                    onChange={props.selectedthisOrderVariant}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{
                        shrink: true,
                      }}
                >
                    <option key="1" value="standard" selected>
                    <IntlMessages id="input.Order.variant.option1"/>
                    </option>
                    <option key="2" value="orderbekraftelse">
                    <IntlMessages id="input.Order.variant.option2"/>
                    </option>
                    
                </TextField>
            </div>
        </form>
    );
}